const BASE = process.env.REACT_APP_API_URL || '/api';

const go = async (method, path, body) => {
  const opts = { method, headers: { 'Content-Type': 'application/json' } };
  if (body !== undefined) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, opts);
  return res.json();
};

export const createBusiness  = (data)           => go('POST',   '/businesses',                      data);
export const getBusiness     = (id)              => go('GET',    `/businesses/${id}`);
export const updateBusiness  = (id, data)        => go('PUT',    `/businesses/${id}`,                data);
export const deleteBusiness  = (id)              => go('DELETE', `/businesses/${id}`);
export const getMembers      = (id)              => go('GET',    `/businesses/${id}/members`);
export const inviteMember    = (id, data)        => go('POST',   `/businesses/${id}/members`,        data);
export const updateMember    = (id, uid, data)   => go('PUT',    `/businesses/${id}/members/${uid}`, data);
export const removeMember    = (id, uid)         => go('DELETE', `/businesses/${id}/members/${uid}`);
export const getDashboard    = (id)              => go('GET',    `/businesses/${id}/dashboard`);
export const getAgenda       = (id, week)        => go('GET',    `/businesses/${id}/agenda?week=${week}`);
export const saveAgenda      = (id, data)        => go('PUT',    `/businesses/${id}/agenda`,         data);
export const importIcal      = (id, data)        => go('POST',   `/businesses/${id}/ical-import`,   data);
export const getBusinessByUser = (uid)           => go('GET',    `/businesses/by-user/${uid}`);
export const getMyBusinesses   = (uid)           => go('GET',    `/businesses/mine?uid=${uid}`);

// Feature 5: Manager Notes
export const getMemberNotes  = (bizId, uid)      => go('GET',    `/businesses/${bizId}/members/${uid}/notes`);
export const saveMemberNotes = (bizId, uid, data)=> go('PUT',    `/businesses/${bizId}/members/${uid}/notes`, data);

// Feature 3: Team Pulse
export const getPulse        = (id, uid)         => go('GET',    `/businesses/${id}/pulse${uid ? `?uid=${uid}` : ''}`);
export const createPulse     = (id, data)        => go('POST',   `/businesses/${id}/pulse`,          data);
export const respondPulse    = (id, pid, data)   => go('POST',   `/businesses/${id}/pulse/${pid}/respond`, data);

// Feature 6: Challenges
export const getChallenges   = (id, week)        => go('GET',    `/businesses/${id}/challenges?week=${week}`);
export const createChallenge = (id, data)        => go('POST',   `/businesses/${id}/challenges`,     data);
export const deleteChallenge = (id, cid)         => go('DELETE', `/businesses/${id}/challenges/${cid}`);

// Feature 9: Departments
export const getDepartments  = (id)              => go('GET',    `/businesses/${id}/departments`);
export const createDepartment= (id, data)        => go('POST',   `/businesses/${id}/departments`,    data);
export const deleteDepartment= (id, did)         => go('DELETE', `/businesses/${id}/departments/${did}`);
export const setMemberDept   = (id, uid, data)   => go('PUT',    `/businesses/${id}/members/${uid}/department`, data);

// Feature 11: Absences
export const getAbsences     = (id, from, to)    => go('GET',    `/businesses/${id}/absences?from=${from}&to=${to}`);
export const logAbsence      = (id, data)        => go('POST',   `/businesses/${id}/absences`,       data);
export const deleteAbsence   = (id, aid)         => go('DELETE', `/businesses/${id}/absences/${aid}`);

// Feature 8/10: Settings
export const getSettings     = (id)              => go('GET',    `/businesses/${id}/settings`);
export const saveSettings    = (id, data)        => go('PUT',    `/businesses/${id}/settings`,       data);
export const testSlack       = (id, data)        => go('POST',   `/businesses/${id}/slack-test`,     data);

// Feature 1: Weekly Report
export const getReport       = (id)              => go('GET',    `/businesses/${id}/report`);

// Feature 12: GDPR Export — returns CSV, open in new tab
export const exportData      = (id)              => `${BASE}/businesses/${id}/export`;

// White-label branding
export const getBranding     = (id)              => go('GET',    `/businesses/${id}/branding`);
export const saveBranding    = (id, data)        => go('PUT',    `/businesses/${id}/branding`,          data);

// ROI dashboard
export const getRoi          = (id)              => go('GET',    `/businesses/${id}/roi`);
export const saveRoi         = (id, data)        => go('PUT',    `/businesses/${id}/roi`,               data);
export const getBenchmarks   = (id)              => go('GET',    `/businesses/${id}/benchmarks`);

// RI&E Assessment
export const getRIESessions  = (id)              => go('GET',    `/businesses/${id}/rie`);
export const createRIESession= (id, data)        => go('POST',   `/businesses/${id}/rie`,               data);
export const closeRIESession = (id, sid)         => go('PUT',    `/businesses/${id}/rie/${sid}`);
export const submitRIEAnswer = (id, sid, data)   => go('POST',   `/businesses/${id}/rie/${sid}/answer`, data);
export const getRIEResults   = (id, sid)         => go('GET',    `/businesses/${id}/rie/${sid}/results`);

// eNPS
export const getEnps         = (id)              => go('GET',    `/businesses/${id}/enps`);
export const submitEnps      = (id, data)        => go('POST',   `/businesses/${id}/enps`,              data);

// Escalations
export const getEscalations      = (id)          => go('GET',    `/businesses/${id}/escalations`);
export const acknowledgeEscalation = (id, eid)   => go('PUT',    `/businesses/${id}/escalations/${eid}`);
export const checkEscalations    = (id)          => go('POST',   `/businesses/${id}/check-escalations`);

// Wellness Programs
export const getPrograms     = (id)              => go('GET',    `/businesses/${id}/programs`);
export const createProgram   = (id, data)        => go('POST',   `/businesses/${id}/programs`,          data);
export const deleteProgram   = (id, pid)         => go('DELETE', `/businesses/${id}/programs/${pid}`);
export const getProgramProgress = (id, pid)      => go('GET',    `/businesses/${id}/programs/${pid}/progress`);
export const saveProgramProgress = (id, pid, data) => go('PUT', `/businesses/${id}/programs/${pid}/progress`, data);

// Quarterly board report
export const getQuarterlyReport = (id)           => go('GET',    `/businesses/${id}/quarterly-report`);

// HRIS CSV import
export const importCSV       = (id, data)        => go('POST',   `/businesses/${id}/csv-import`,        data);

// User search (for inviting existing SL users by name)
export const searchUsers       = (q, exclude)    => go('GET',    `/users/search?q=${encodeURIComponent(q)}${exclude ? '&exclude='+exclude : ''}`);

// Invites
export const createBizInvite  = (id, data)       => go('POST',   `/businesses/${id}/invites`,           data);
export const getBizInvites    = (id)              => go('GET',    `/businesses/${id}/invites`);
export const deleteBizInvite  = (id, iid)        => go('DELETE', `/businesses/${id}/invites/${iid}`);
export const getBizInviteInfo = (token)          => go('GET',    `/business-invite/${token}`);
export const acceptBizInvite  = (token, data)    => go('POST',   `/business-invite/${token}/accept`,    data);

// Role management
export const updateMemberRole    = (bizId, uid, role)    => go('PUT',    `/businesses/${bizId}/members/${uid}/role`,     { role });

// Member sharing & wellness stats
export const setMemberSharing    = (bizId, uid, enabled) => go('PUT',    `/businesses/${bizId}/members/${uid}/sharing`,  { enabled });
export const getMemberWellness   = (bizId, uid)          => go('GET',    `/businesses/${bizId}/members/${uid}/wellness`);

// Services
export const getServices         = (id)          => go('GET',    `/businesses/${id}/services?all=1`);
export const createService       = (id, data)    => go('POST',   `/businesses/${id}/services`,       data);
export const updateService       = (id, sid, d)  => go('PUT',    `/businesses/${id}/services/${sid}`, d);
export const deleteService       = (id, sid)     => go('DELETE', `/businesses/${id}/services/${sid}`);

// Service bookings
export const getBookings         = (id)          => go('GET',    `/businesses/${id}/bookings`);
export const createBooking       = (id, data)    => go('POST',   `/businesses/${id}/bookings`,       data);
export const updateBooking       = (id, bid, d)  => go('PUT',    `/businesses/${id}/bookings/${bid}`, d);

// Public business page (no auth)
export const getBizPage          = (id)          => go('GET',    `/bizpage/${id}`);
export const getBizPageFeed      = (id)          => go('GET',    `/bizpage/${id}/feed`);
export const publicBook          = (id, data)    => go('POST',   `/bizpage/${id}/book`, data);

// Business private feed
export const getBizFeed          = (bizId, vis)  => go('GET',    `/businesses/${bizId}/feed${vis ? '?visibility='+vis : ''}`);
export const postToBizFeed       = (bizId, data) => go('POST',   `/businesses/${bizId}/feed`,        data);
export const setBizPostVisibility= (bizId, fid, vis) => go('PUT', `/businesses/${bizId}/feed/${fid}`, { visibility: vis });
export const deleteBizFeedPost   = (bizId, fid)  => go('DELETE', `/businesses/${bizId}/feed/${fid}`);

// Post sharing (community)
export const sharePost           = (uid, data)   => go('POST',   `/posts/${uid}/share`,              data);

// HR – Contracts
export const getContracts        = (bizId)               => go('GET',    `/businesses/${bizId}/contracts`);
export const getContract         = (bizId, uid)          => go('GET',    `/businesses/${bizId}/contracts/${uid}`);
export const saveContract        = (bizId, data)         => go('POST',   `/businesses/${bizId}/contracts`,        data);
export const updateContract      = (bizId, uid, data)    => go('PUT',    `/businesses/${bizId}/contracts/${uid}`, data);
export const deleteContract      = (bizId, uid)          => go('DELETE', `/businesses/${bizId}/contracts/${uid}`);

// HR – Leave requests
export const getLeaveRequests    = (bizId, params)       => go('GET',    `/businesses/${bizId}/leave${params ? '?'+new URLSearchParams(params) : ''}`);
export const submitLeaveRequest  = (bizId, data)         => go('POST',   `/businesses/${bizId}/leave`,            data);
export const reviewLeaveRequest  = (bizId, lid, data)    => go('PUT',    `/businesses/${bizId}/leave/${lid}`,     data);
export const deleteLeaveRequest  = (bizId, lid)          => go('DELETE', `/businesses/${bizId}/leave/${lid}`);

// HR – Sick reports
export const getSickReports      = (bizId, params)       => go('GET',    `/businesses/${bizId}/sick${params ? '?'+new URLSearchParams(params) : ''}`);
export const fileSickReport      = (bizId, data)         => go('POST',   `/businesses/${bizId}/sick`,             data);
export const markRecovered       = (bizId, sid, data)    => go('PUT',    `/businesses/${bizId}/sick/${sid}`,      data);

// HR – Leave balance
export const getLeaveBalance     = (bizId, year)         => go('GET',    `/businesses/${bizId}/leave-balance${year ? '?year='+year : ''}`);

// HR – hr_role on members
export const updateMemberHrRole  = (bizId, uid, hrRole)  => go('PUT',    `/businesses/${bizId}/members/${uid}/role`, { hr_role: hrRole });

// Training completion tracking
export const completeTraining    = (bizId, data)         => go('POST',   `/businesses/${bizId}/training/complete`, data);

// ── Customers (CRM) ────────────────────────────────────────────────────────────
export const getCustomers       = (bizId)             => go('GET',    `/businesses/${bizId}/customers`);
export const createCustomer     = (bizId, data)       => go('POST',   `/businesses/${bizId}/customers`,          data);
export const updateCustomer     = (bizId, cid, data)  => go('PUT',    `/businesses/${bizId}/customers/${cid}`,   data);
export const deleteCustomer     = (bizId, cid)        => go('DELETE', `/businesses/${bizId}/customers/${cid}`);
export const getCustomerHistory = (bizId, cid)        => go('GET',    `/businesses/${bizId}/customers/${cid}/history`);
export const addCustomerNote    = (bizId, cid, data)  => go('POST',   `/businesses/${bizId}/customers/${cid}/notes`, data);
export const getCustomerNote    = (bizId, cid)        => go('GET',    `/businesses/${bizId}/customers/${cid}/notes`);
export const importCustomersCSV = (bizId, data)       => go('POST',   `/businesses/${bizId}/customers/import`,   data);

// ── Enhanced Bookings ──────────────────────────────────────────────────────────
export const getBookingsRange   = (bizId, from, to)   => go('GET',    `/businesses/${bizId}/bookings?from=${from}&to=${to}`);
export const deleteBooking      = (bizId, bid)        => go('DELETE', `/businesses/${bizId}/bookings/${bid}`);
export const sendBookingForm    = (bizId, data)       => go('POST',   `/businesses/${bizId}/bookings/send-form`, data);
export const getBookingWidget   = (bizId)             => go('GET',    `/businesses/${bizId}/booking-widget`);
export const saveBookingWidget  = (bizId, data)       => go('PUT',    `/businesses/${bizId}/booking-widget`,    data);
export const getServiceSlots    = (bizId, sid, date)  => go('GET',    `/businesses/${bizId}/services/${sid}/slots?date=${date}`);

// ── Products ───────────────────────────────────────────────────────────────────
export const getProducts        = (bizId)             => go('GET',    `/businesses/${bizId}/products`);
export const createProduct      = (bizId, data)       => go('POST',   `/businesses/${bizId}/products`,          data);
export const updateProduct      = (bizId, pid, data)  => go('PUT',    `/businesses/${bizId}/products/${pid}`,   data);
export const deleteProduct      = (bizId, pid)        => go('DELETE', `/businesses/${bizId}/products/${pid}`);

// ── Orders ────────────────────────────────────────────────────────────────────
export const getOrders          = (bizId)             => go('GET',    `/businesses/${bizId}/orders`);
export const createOrder        = (bizId, data)       => go('POST',   `/businesses/${bizId}/orders`,            data);
export const updateOrder        = (bizId, oid, data)  => go('PUT',    `/businesses/${bizId}/orders/${oid}`,     data);
export const deleteOrder        = (bizId, oid)        => go('DELETE', `/businesses/${bizId}/orders/${oid}`);

// ── API key management ────────────────────────────────────────────────────────
export const getApiKey          = (bizId)             => go('GET',    `/businesses/${bizId}/api-key`);
export const regenerateApiKey   = (bizId)             => go('POST',   `/businesses/${bizId}/api-key`);
export const saveApiKeySettings = (bizId, data)       => go('PUT',    `/businesses/${bizId}/api-key`,           data);

// ── Tasks ─────────────────────────────────────────────────────────────────────
export const getTasks           = (bizId, params)     => go('GET',    `/businesses/${bizId}/tasks${params ? '?'+new URLSearchParams(params) : ''}`);
export const createTask         = (bizId, data)       => go('POST',   `/businesses/${bizId}/tasks`,             data);
export const updateTask         = (bizId, tid, data)  => go('PUT',    `/businesses/${bizId}/tasks/${tid}`,      data);
export const deleteTask         = (bizId, tid)        => go('DELETE', `/businesses/${bizId}/tasks/${tid}`);

// ── Projects ──────────────────────────────────────────────────────────────────
export const getProjects        = (bizId)             => go('GET',    `/businesses/${bizId}/projects`);
export const createProject      = (bizId, data)       => go('POST',   `/businesses/${bizId}/projects`,          data);
export const updateProject      = (bizId, pid, data)  => go('PUT',    `/businesses/${bizId}/projects/${pid}`,   data);
export const deleteProject      = (bizId, pid)        => go('DELETE', `/businesses/${bizId}/projects/${pid}`);

// ── Sprints ───────────────────────────────────────────────────────────────────
export const getSprints         = (bizId, pid)        => go('GET',    `/businesses/${bizId}/projects/${pid}/sprints`);
export const createSprint       = (bizId, pid, data)  => go('POST',   `/businesses/${bizId}/projects/${pid}/sprints`,         data);
export const updateSprint       = (bizId, pid, sid, d)=> go('PUT',    `/businesses/${bizId}/projects/${pid}/sprints/${sid}`,  d);
export const deleteSprint       = (bizId, pid, sid)   => go('DELETE', `/businesses/${bizId}/projects/${pid}/sprints/${sid}`);

// ── Stories ───────────────────────────────────────────────────────────────────
export const getStories         = (bizId, pid)        => go('GET',    `/businesses/${bizId}/projects/${pid}/stories`);
export const createStory        = (bizId, pid, data)  => go('POST',   `/businesses/${bizId}/projects/${pid}/stories`,         data);
export const updateStory        = (bizId, pid, stid, d)=> go('PUT',   `/businesses/${bizId}/projects/${pid}/stories/${stid}`, d);
export const deleteStory        = (bizId, pid, stid)  => go('DELETE', `/businesses/${bizId}/projects/${pid}/stories/${stid}`);

// ── Administration – Invoices ─────────────────────────────────────────────────
export const getInvoices         = (bizId)              => go('GET',    `/businesses/${bizId}/invoices`);
export const createInvoice       = (bizId, data)        => go('POST',   `/businesses/${bizId}/invoices`,              data);
export const updateInvoice       = (bizId, id, data)    => go('PUT',    `/businesses/${bizId}/invoices/${id}`,        data);
export const deleteInvoice       = (bizId, id)          => go('DELETE', `/businesses/${bizId}/invoices/${id}`);
export const sendInvoice         = (bizId, id, data)    => go('POST',   `/businesses/${bizId}/invoices/${id}/send`,   data);

// ── Administration – Bills ────────────────────────────────────────────────────
export const getBills            = (bizId)              => go('GET',    `/businesses/${bizId}/bills`);
export const createBill          = (bizId, data)        => go('POST',   `/businesses/${bizId}/bills`,                 data);
export const updateBill          = (bizId, id, data)    => go('PUT',    `/businesses/${bizId}/bills/${id}`,           data);
export const deleteBill          = (bizId, id)          => go('DELETE', `/businesses/${bizId}/bills/${id}`);

// ── Administration – Expenses ─────────────────────────────────────────────────
export const getExpenses         = (bizId, p)           => go('GET',    `/businesses/${bizId}/expenses${p ? '?'+new URLSearchParams(p) : ''}`);
export const createExpense       = (bizId, data)        => go('POST',   `/businesses/${bizId}/expenses`,              data);
export const updateExpense       = (bizId, id, data)    => go('PUT',    `/businesses/${bizId}/expenses/${id}`,        data);
export const deleteExpense       = (bizId, id)          => go('DELETE', `/businesses/${bizId}/expenses/${id}`);

// ── Administration – Ledger ───────────────────────────────────────────────────
export const getJournal          = (bizId)              => go('GET',    `/businesses/${bizId}/journal`);
export const createJournalEntry  = (bizId, data)        => go('POST',   `/businesses/${bizId}/journal`,               data);
export const getLedgerBalance    = (bizId)              => go('GET',    `/businesses/${bizId}/ledger/balance`);
export const getLedgerPL         = (bizId, p)           => go('GET',    `/businesses/${bizId}/ledger/pl${p ? '?'+new URLSearchParams(p) : ''}`);

// ── Administration – Accounting Connections ───────────────────────────────────
export const getAccountingConnections   = (bizId)         => go('GET',    `/businesses/${bizId}/accounting-connections`);
export const saveAccountingConnection   = (bizId, data)   => go('PUT',    `/businesses/${bizId}/accounting-connections`, data);
export const syncAccountingConnection   = (bizId, data)   => go('POST',   `/businesses/${bizId}/accounting-connections/sync`, data);
export const deleteAccountingConnection = (bizId, prov)   => go('DELETE', `/businesses/${bizId}/accounting-connections/${prov}`);

// ── Ownership Transfer ────────────────────────────────────────────────────────
export const initiateTransfer         = (bizId, data)  => go('POST',   `/businesses/${bizId}/transfer/initiate`,           data);
export const generateTransferContract = (bizId, data)  => go('POST',   `/businesses/${bizId}/transfer/generate-contract`,  data);
export const confirmTransfer          = (bizId, data)  => go('POST',   `/businesses/${bizId}/transfer/confirm`,            data);
export const getTransfers             = (bizId)        => go('GET',    `/businesses/${bizId}/transfers`);

// ── Transfer Stripe Connect payments ─────────────────────────────────────────
export const onboardTransferSeller    = (bizId, tid)         => go('POST',   `/businesses/${bizId}/transfer/${tid}/stripe/onboard-seller`);
export const getTransferOnboardStatus = (bizId, tid)         => go('GET',    `/businesses/${bizId}/transfer/${tid}/stripe/onboard-status`);
export const scheduleTransferInstallments = (bizId, tid, d)  => go('POST',   `/businesses/${bizId}/transfer/${tid}/stripe/schedule`, d);
export const getTransferInstallments  = (bizId, tid)         => go('GET',    `/businesses/${bizId}/transfer/${tid}/stripe/installments`);
export const createTransferCheckout   = (bizId, tid, d)      => go('POST',   `/businesses/${bizId}/transfer/${tid}/stripe/checkout`, d);
export const getTransferPaymentStatus = (bizId, tid, sid, inst) => go('GET', `/businesses/${bizId}/transfer/${tid}/stripe/payment-status?session_id=${sid}&inst=${inst}`);
